
'use strict';//Indicating browser should run only in java script mode


var EMREnCounterPartcipants = angular.module('EMR.EncounterPartcipants', ['EMR.Admin'])